import { createReducer } from '@reduxjs/toolkit';

import * as eventsActions from './eventsActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  sid: 0,
  type: 'events',
  isActive: false,
  isAdded: false,

  headingTitle: '',
  headingImage: '',
  headingTextAlign: 'left',
  headingDescription: '',
  headingDivider: '',

  sectionIsBackground: false,
  sectionTextColor: '#000000',
  sectionShadow: 'soft',
  sectionShadowColor: '#000',
  sectionShadowBorderColor: '#000',
  sectionBorderColor: '#000',
  sectionShape: 'round',
  sectionOpacity: 0,
  sectionBackgroundColor: '#ffffff',
  sectionIsFullWidth: false,
  sectionPadding: 20,
  sectionMargin: 12,
  sectionBackgroundType: 1,
  sectionBackgroundImage: '',
  sectionGradientColor1: '#B3F7EF',
  sectionGradientColor2: '#F7D6E0',
  sectionGradientDirection: 0,
  sectionGradientOffset: 0,
  sectionBorder: 'none',

  itemShadow: 'none',
  itemShadowColor: '#000',
  itemBorder: 'none',
  itemBorderColor: '#000',
  itemShape: 'round',
  itemTextColor: '#000',
  itemBackgroundColor: '#ffffff',

  view: 'squareEvents',

  items: [],
};

const events = createReducer(initialState, (builder) => {
  builder
    .addCase(eventsActions.eventsUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(eventsActions.eventsUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(eventsActions.eventsUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(eventsActions.eventsStore, (state, { payload }) => {
      const { id, uid, sid, isAdded, isActive, data } = payload;

      const section = data ?? {};
      const {
        headingTitle,
        headingDescription,
        headingImage,
        headingTextAlign,
        headingDivider,

        sectionBackgroundColor,
        sectionTextColor,
        sectionOpacity,
        sectionIsFullWidth,
        sectionShadow,
        sectionShadowColor,
        sectionShadowBorderColor,
        sectionPadding,
        sectionMargin,
        isSectionBackground,
        sectionBackgroundType,
        sectionBackgroundImage,
        sectionGradientColor1,
        sectionGradientColor2,
        sectionGradientDirection,
        sectionGradientOffset,
        sectionShape,
        sectionBorderColor,
        sectionBorder,

        itemShadow,
        itemShadowColor,
        itemShape,
        itemBorder,
        itemBorderColor,
        itemTextColor,
        itemBackgroundColor,

        view,
        items,
      } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: id ?? 0,
        uid: uid ?? 0,
        sid: sid ?? 0,
        isActive: isActive,
        isAdded: isAdded,

        headingTextAlign: headingTextAlign ?? 'center',
        headingTitle: headingTitle ?? '',
        headingDescription: headingDescription ?? '',
        headingImage: headingImage ?? '',
        headingDivider: headingDivider ?? '',

        sectionMargin: sectionMargin,
        sectionBackgroundColor: sectionBackgroundColor ?? '#ffffff',
        sectionTextColor: sectionTextColor ?? '#000000',
        sectionOpacity: sectionOpacity ?? 0,
        sectionIsFullWidth: sectionIsFullWidth ?? false,
        sectionShadow: sectionShadow ?? 'none',
        sectionShadowColor: sectionShadowColor ?? '#000',
        sectionPadding: sectionPadding,
        sectionIsBackground: isSectionBackground ?? false,
        sectionBackgroundType: sectionBackgroundType ?? 1,
        sectionBackgroundImage: sectionBackgroundImage ?? '',
        sectionGradientColor1: sectionGradientColor1 ?? '#B3F7EF',
        sectionGradientColor2: sectionGradientColor2 ?? '#F7D6E0',
        sectionGradientDirection: sectionGradientDirection ?? 0,
        sectionGradientOffset: sectionGradientOffset ?? 0,
        sectionShadowBorderColor: sectionShadowBorderColor ?? '#000',
        sectionBorderColor: sectionBorderColor ?? '#000',
        sectionShape: sectionShape ?? 'round',
        sectionBorder: sectionBorder ?? 'none',

        itemShadow: itemShadow ?? 'none',
        itemShadowColor: itemShadowColor ?? '#000',
        itemShape: itemShape ?? 'round',
        itemBorder: itemBorder ?? 'none',
        itemBorderColor: itemBorderColor ?? '#000',
        itemTextColor: itemTextColor ?? '#000',
        itemBackgroundColor: itemBackgroundColor ?? '#ffffff',

        view: view ?? 'squareEvents',

        items: items ?? [],
      };
    })

    .addCase(eventsActions.eventsClear, () => ({ ...initialState }))

    .addCase(eventsActions.eventsUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(eventsActions.eventsUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(eventsActions.eventsUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(eventsActions.eventsUpdateHeadingTitle, (state, { payload: headingTitle }) => ({ ...state, headingTitle }))
    .addCase(eventsActions.eventsUpdateHeadingDescription, (state, { payload: headingDescription }) => ({ ...state, headingDescription }))
    .addCase(eventsActions.eventsUpdateHeadingTextAlign, (state, { payload: headingTextAlign }) => ({ ...state, headingTextAlign }))
    .addCase(eventsActions.eventsUpdateHeadingImage, (state, { payload: headingImage }) => ({ ...state, headingImage }))
    .addCase(eventsActions.eventsUpdateHeadingDivider, (state, { payload: headingDivider }) => ({ ...state, headingDivider }))

    .addCase(eventsActions.eventsUpdateSectionIsBackground, (state, { payload: sectionIsBackground }) => ({ ...state, sectionIsBackground }))
    .addCase(eventsActions.eventsUpdateSectionTextColor, (state, { payload: sectionTextColor }) => ({ ...state, sectionTextColor }))
    .addCase(eventsActions.eventsUpdateSectionBackgroundColor, (state, { payload: sectionBackgroundColor }) => ({ ...state, sectionBackgroundColor }))
    .addCase(eventsActions.eventsUpdateSectionOpacity, (state, { payload: sectionOpacity }) => ({ ...state, sectionOpacity }))
    .addCase(eventsActions.eventsUpdateSectionIsFullWidth, (state, { payload: sectionIsFullWidth }) => ({ ...state, sectionIsFullWidth }))
    .addCase(eventsActions.eventsUpdateSectionShadow, (state, { payload: sectionShadow }) => ({ ...state, sectionShadow }))
    .addCase(eventsActions.eventsUpdateSectionShadowColor, (state, { payload: sectionShadowColor }) => ({ ...state, sectionShadowColor }))
    .addCase(eventsActions.eventsUpdateSectionPadding, (state, { payload: sectionPadding }) => ({ ...state, sectionPadding }))
    .addCase(eventsActions.eventsUpdateSectionMargin, (state, { payload: sectionMargin }) => ({ ...state, sectionMargin }))
    .addCase(eventsActions.eventsUpdateSectionBackgroundType, (state, { payload: sectionBackgroundType }) => ({ ...state, sectionBackgroundType }))
    .addCase(eventsActions.eventsUpdateSectionBackgroundImage, (state, { payload: sectionBackgroundImage }) => ({ ...state, sectionBackgroundImage }))
    .addCase(eventsActions.eventsUpdateSectionGradientColor1, (state, { payload: sectionGradientColor1 }) => ({ ...state, sectionGradientColor1 }))
    .addCase(eventsActions.eventsUpdateSectionGradientColor2, (state, { payload: sectionGradientColor2 }) => ({ ...state, sectionGradientColor2 }))
    .addCase(eventsActions.eventsUpdateSectionGradientDirection, (state, { payload: sectionGradientDirection }) => ({ ...state, sectionGradientDirection }))
    .addCase(eventsActions.eventsUpdateSectionGradientOffset, (state, { payload: sectionGradientOffset }) => ({ ...state, sectionGradientOffset }))
    .addCase(eventsActions.eventsUpdateSectionShadowBorderColor, (state, { payload: sectionShadowBorderColor }) => ({ ...state, sectionShadowBorderColor }))
    .addCase(eventsActions.eventsUpdateSectionBorderColor, (state, { payload: sectionBorderColor }) => ({ ...state, sectionBorderColor }))
    .addCase(eventsActions.eventsUpdateSectionShape, (state, { payload: sectionShape }) => ({ ...state, sectionShape }))
    .addCase(eventsActions.eventsUpdateSectionBorder, (state, { payload: sectionBorder }) => ({ ...state, sectionBorder }))

    .addCase(eventsActions.eventsUpdateItemShadow, (state, { payload: itemShadow }) => ({ ...state, itemShadow }))
    .addCase(eventsActions.eventsUpdateItemShadowColor, (state, { payload: itemShadowColor }) => ({ ...state, itemShadowColor }))
    .addCase(eventsActions.eventsUpdateItemShape, (state, { payload: itemShape }) => ({ ...state, itemShape }))
    .addCase(eventsActions.eventsUpdateItemBorder, (state, { payload: itemBorder }) => ({ ...state, itemBorder }))
    .addCase(eventsActions.eventsUpdateItemBorderColor, (state, { payload: itemBorderColor }) => ({ ...state, itemBorderColor }))
    .addCase(eventsActions.eventsUpdateItemTextColor, (state, { payload: itemTextColor }) => ({ ...state, itemTextColor }))
    .addCase(eventsActions.eventsUpdateItemBackgroundColor, (state, { payload: itemBackgroundColor }) => ({ ...state, itemBackgroundColor }))

    .addCase(eventsActions.eventsUpdateView, (state, { payload: view }) => ({ ...state, view }))
    .addCase(eventsActions.eventsUpdateItems, (state, { payload: items }) => ({ ...state, items }));
});

export default events;
